import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const seoData = {
  '/': {
    title: 'Dream Room Theaters — Premium Custom Home Theater Design & Installation',
    description: 'Building the best theater rooms since 2013. Premium custom home theater design, installation, and service across Canada. Transform your space into a cinematic oasis.',
    keywords: 'home theater, custom theater room, theater design, home cinema, luxury theater, Toronto, Canada, AV installation',
  },
  '/packages': {
    title: 'Our Packages — Dream Room Theaters',
    description: 'Explore our Matinee Haven, Premiere Lounge, and Director\'s Suite packages. Tiered luxury home theater packages with premium seating, surround sound, and custom design.',
    keywords: 'theater packages, home theater pricing, matinee haven, premiere lounge, directors suite, custom theater',
  },
  '/gallery': {
    title: 'Gallery — Dream Room Theaters',
    description: 'Explore our portfolio of completed theater rooms, AV installations, custom concession stands, and specialty items. Find inspiration for your dream theater.',
    keywords: 'theater gallery, home theater portfolio, theater room photos, completed projects, before after',
  },
  '/design-your-theater': {
    title: 'Custom Room Designer — Dream Room Theaters',
    description: 'Design your dream home theater room. Configure room size, seating, screen type, sound system, ceiling design, lighting, and more with our interactive room builder.',
    keywords: 'room designer, theater configurator, custom theater builder, design home theater, room planner',
  },
  '/book': {
    title: 'Book a Consultation — Dream Room Theaters',
    description: 'Book a personalized consultation with Dream Room Theaters. Let our experts turn your vision into a luxurious in-home cinematic experience.',
    keywords: 'book consultation, theater consultation, schedule appointment, home theater booking',
  },
  '/contact': {
    title: 'Contact Us — Dream Room Theaters',
    description: 'Get in touch with Dream Room Theaters. Contact us about custom home theater design, AV installation, maintenance, and more.',
    keywords: 'contact, dream room theaters, home theater company, theater installation Toronto',
  },
  '/services': {
    title: 'Services & Maintenance — Dream Room Theaters',
    description: 'Theater cleaning, maintenance, and warranty packages. Keep your home theater in pristine condition with our professional services.',
    keywords: 'theater maintenance, cleaning service, warranty, theater service, AV maintenance',
  },
};

export const SEOHead = () => {
  const location = useLocation();

  useEffect(() => {
    const data = seoData[location.pathname] || seoData['/'];

    document.title = data.title;

    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = data.description;

    // Meta keywords
    let metaKeys = document.querySelector('meta[name="keywords"]');
    if (!metaKeys) {
      metaKeys = document.createElement('meta');
      metaKeys.name = 'keywords';
      document.head.appendChild(metaKeys);
    }
    metaKeys.content = data.keywords;

    // OpenGraph tags
    const ogTags = {
      'og:title': data.title,
      'og:description': data.description,
      'og:type': 'website',
      'og:site_name': 'Dream Room Theaters',
      'og:url': window.location.href,
      'og:image': 'https://static.prod-images.emergentagent.com/jobs/5673d3ec-9da0-4482-ba34-3bd63a96723f/images/5fba529f4f19e986acd4a7a8cfe3f6705025bcc0e1c9c2c73305412ffc96f00b.jpeg',
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });

    // Twitter Card
    const twitterTags = {
      'twitter:card': 'summary_large_image',
      'twitter:title': data.title,
      'twitter:description': data.description,
      'twitter:image': 'https://static.prod-images.emergentagent.com/jobs/5673d3ec-9da0-4482-ba34-3bd63a96723f/images/5fba529f4f19e986acd4a7a8cfe3f6705025bcc0e1c9c2c73305412ffc96f00b.jpeg',
    };

    Object.entries(twitterTags).forEach(([name, content]) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, [location.pathname]);

  return null;
};
